module.exports = __webpack_public_path__ + "static/media/topography-dark.2dc57f26.svg";